export function authHeader() {
	// return authorization header with jwt token
	let user = JSON.parse(localStorage.getItem("user"))
	if (user && user.token.access_token) {
		return {
			"Content-Type": "application/json",
			accept: "application/json",
			auth_token: user.token.access_token,
			"auth-token": user.token.access_token,
			Authorization: "Bearer " + user.token.access_token,
		}
	} else {
		return {}
	}
}
